import Components from "../components";
import moment from "moment";

class TzOffset extends Components.Base {
  initialize() {
    $.cookie("tzOffset", moment().utcOffset() * 60, {
      path: "/",
      expires: new Date(new Date().getTime() + 1000 * 60 * 60 * 24),
    });
  }
}

Components.collection.register({ selector: ".main", klass: TzOffset });
